import { render, staticRenderFns } from "./messagePage.vue?vue&type=template&id=48e0b485&scoped=true&"
import script from "./messagePage.vue?vue&type=script&lang=js&"
export * from "./messagePage.vue?vue&type=script&lang=js&"
import style0 from "./messagePage.vue?vue&type=style&index=0&id=48e0b485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0b485",
  null
  
)

export default component.exports